module.exports = __webpack_public_path__ + "img/logo-login.b30c52ef.svg";